import { render, staticRenderFns } from "./DropDownStudents.vue?vue&type=template&id=607113ee&scoped=true"
import script from "./DropDownStudents.vue?vue&type=script&lang=js"
export * from "./DropDownStudents.vue?vue&type=script&lang=js"
import style0 from "./DropDownStudents.vue?vue&type=style&index=0&id=607113ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607113ee",
  null
  
)

export default component.exports